export default "__VITE_ASSET__DXDiGDFV__"